import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getLaunchTokenFromUrl } from './onlinePlayerSession';
import './OnlineGameMenu.css';

function OnlineGameMenu() {
  const menuRef = useRef(null);
  const launchToken = getLaunchTokenFromUrl();
  const queryString = launchToken ? `?launchToken=${encodeURIComponent(launchToken)}` : '';

  const closeMenu = () => {
    if (menuRef.current) {
      menuRef.current.open = false;
    }
  };

  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      const menu = menuRef.current;

      if (menu?.open && !menu.contains(event.target)) {
        menu.open = false;
      }
    };

    document.addEventListener('pointerdown', closeMenuOnOutsideClick);

    return () => {
      document.removeEventListener('pointerdown', closeMenuOnOutsideClick);
    };
  }, []);

  return (
    <details ref={menuRef} className="online-game-menu">
      <summary aria-label="Open online roulette menu">
        <span className="online-game-menu__dots" aria-hidden="true">
          <i></i>
          <i></i>
          <i></i>
        </span>
        <b>Menu</b>
      </summary>
      <nav className="online-game-menu__list" aria-label="Online roulette pages">
        <Link to={`/onlineroulette${queryString}`} onClick={closeMenu}>Betting</Link>
        <Link to={`/userhistory${queryString}`} onClick={closeMenu}>History</Link>
        <Link to={`/paytable${queryString}`} onClick={closeMenu}>Pay Table</Link>
        <Link to={`/rules${queryString}`} onClick={closeMenu}>Rules</Link>
      </nav>
    </details>
  );
}

export default OnlineGameMenu;
